import type { DataTableColumn } from '@/components/custom/erp';
import { usePasteConfig } from '@/components/custom/erp';
import type { DetailRow } from './useDetailRows';

interface UseDetailPasteProps {
  columns: DataTableColumn<DetailRow>[];
  handleUpdateNonWritableFields?: (fields: Set<string>) => void;
  handleUpdatePasteConfigs?: (
    configs: Record<string, { resolver: (codes: string[]) => Promise<unknown[]>; resultField?: string }>
  ) => void;
}

export const useDetailPaste = ({
  columns,
  handleUpdateNonWritableFields,
  handleUpdatePasteConfigs
}: UseDetailPasteProps) => {
  return usePasteConfig({
    columns,
    onNonWritableFields: handleUpdateNonWritableFields,
    onPasteConfigs: handleUpdatePasteConfigs
  });
};
